import { batchActions } from 'redux-batched-actions';
import { $stateParams } from '../../router';
import RsvpService from '../RsvpService';
import GeckoStore from '../GeckoStore';
import { 
    updateAccount,
    updateContact,
    updateEventAttendance,
    replaceEvents,
    replaceSessions,
    replaceAttendances,
    replaceHosts,
} from '../../redux/actions';


export const updateReduxStore = (data) => {
    let actions = [];
    if (data.account) actions.push(updateAccount(data.account));
    if (data.contact) actions.push(updateContact(data.contact));
    if (data.eventAttendance) actions.push(updateEventAttendance(data.eventAttendance));
    if (data.sessions) actions.push(replaceSessions(data.sessions));
    if (data.events) actions.push(replaceEvents(data.events));
    if (data.attendances) actions.push(replaceAttendances(data.attendances));
    if (data.hosts) actions.push(replaceHosts(data.hosts));
    GeckoStore.redux.dispatch(batchActions(actions));
};

export const RefreshData = () => {
    const dataInstance = new RsvpService();
    return dataInstance.getRsvp($stateParams).then(data => {
        data = dataInstance.parseRsvp(data);
        updateReduxStore(data);
        return data;
    });
};

export default RefreshData;